import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMoods } from '../../actions/filterActions'

const MoodFilterComponent = (props) => {

    const dispatch = useDispatch()

    const {error, loading, moods, message} = useSelector(state => state.moods)

    React.useEffect(()=>{
    
        if(props.lastChangedComponent !== props.componentId ){
            dispatch(getMoods(props.filterList))
        }
    
    },[props.filterList])


    const chooseHandler = (mood) => {
        if (props.filterList.filter(g => g[0] === mood.id && g[2] === props.componentId ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [mood.id, mood.title, props.componentId]]})
        } else{
            props.setFilterList((prevArr) => 
                prevArr.filter(item => item[0] !== mood.id)
            )
        }
        props.setLastChangedComponent(props.componentId)
    }

    return (
        <div className = "w-100 d-flex flex-column py-4">
            {
                loading ? 
                <div className='w-100 text-info position-relative p-2 rounded'
                    style={{zIndex:'1000'}}
                >Loading...</div> :
                moods && moods.length ?
                <div className = "w-100 position-relative mt-3 p-2 d-flex gap-2 flex-wrap rounded " 
                    style = {{color:"#333", zIndex:1000}}
                    >
                        {
                            moods.map((result) => (
                                <div
                                className = 
                                    {
                                        props.filterList.some(component => component[0] === result.id && component[2] === props.componentId) ?
                                        "py-1 px-4 text-backcolor text-center rounded-pill bg-info" : 
                                        "py-1 px-4 text-info text-center rounded-pill bg-blueazur"
                                    }                                    
                                    role = "button"
                                    style={{transition:"all 0.2s"}}
                                    key = {result.id}
                                    onClick={()=>chooseHandler(result)}
                                >
                                    {result.title}
                                </div>
                            ))
                        }
                </div> : 
                message ?
                <div className='w-100 text-info position-relative p-2 rounded'>
                    {message}
                </div> : ""
            }
        </div>
    );
};

export default MoodFilterComponent;